// extracted by mini-css-extract-plugin
export default {"error":"RegQuestions_error__7X7e0","boldTextCheckbox":"RegQuestions_boldTextCheckbox__lDbWA"};